<template>
  <div class="Calculator">
    <iframe
      class="iw-html-frame"
      scrolling="no"
      src="https://720yun.gugushuzi.com/project2/"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/Calculator.vue